// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"b935a72d","160":"45400d1c","395":"d6ae202d","453":"b1679f88","500":"61ab865c","515":"29fe72fe","545":"73126ed3","658":"844e4d0e","672":"db0865e9","723":"fea66036","795":"31c0ce44","800":"e1b340bd","863":"925eae57","930":"9b16a8d9"}[chunkId] + ".chunk.js";
};